class LocationMap {
    constructor(mapElementId, locations, options = {}) {
        this.mapElementId = mapElementId;
        this.locations = locations;
        this.options = {
            defaultCoordinates: { lat: 41.6816, lng: -72.9493 },
            markerColor: '#7C9AFF',
            mapId: '5ad7f9ca4b460a70',
            ...options
        };
        this.map = null;
        this.bounds = null;
    }

    init() {
        const mapOptions = {
            center: this.options.defaultCoordinates,
            disableDefaultUI: true,
            mapId: this.options.mapId
        };

        this.map = new google.maps.Map(
            document.getElementById(this.mapElementId),
            mapOptions
        );
        this.bounds = new google.maps.LatLngBounds();

        this.map.setOptions({
            zoomControl: true,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true
        });

        this.addMarkers();
        this.setMapBounds();
    }

    createCustomMarkerContent() {
        const pinBackground = this.options.markerColor;
        const size = 24; // Base size of the marker

        return `
            <div style="
                width: ${size * 2}px;
                height: ${size * 2}px;
                position: relative;
                cursor: pointer;
            ">
                <svg viewBox="0 0 24 24" 
                     style="
                        width: ${size * 2}px;
                        height: ${size * 2}px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        fill: ${pinBackground};
                        stroke: #000000;
                        stroke-width: 1;
                     "
                >
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
                </svg>
            </div>
        `;
    }

    addMarkers() {
        this.locations.forEach((location) => {
            const position = {
                lat: location.latitude
                    ? parseFloat(location.latitude)
                    : this.options.defaultCoordinates.lat,
                lng: location.longitude
                    ? parseFloat(location.longitude)
                    : this.options.defaultCoordinates.lng
            };

            const sanitizedAddress = location.address
                .replace(/<\/?[^>]+(>|$)/g, '')
                .replace(/&nbsp;/g, ' ')
                .trim();

            const directionsLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(sanitizedAddress)}`;

            const infoWindowContent = `
                <div>
                    <strong class="text-lg">${location.name}</strong><br>
                    ${location.address}<br>
                    ${location.phone ? `<a class="text-brand-sky" href="tel:${location.phone}">${location.phone}</a><br>` : ''}
                    <a href="${directionsLink}" target="_blank" class="text-lg text-brand-navy">Get Directions</a>
                </div>
            `;

            const infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });

            // Create the marker element
            const markerContent = document.createElement('div');
            markerContent.innerHTML = this.createCustomMarkerContent();

            // Create the advanced marker
            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                position,
                title: location.name,
                content: markerContent.firstElementChild
            });

            // Add click listener
            marker.addListener('click', () => {
                infoWindow.open({
                    anchor: marker,
                    map: this.map
                });
            });

            this.bounds.extend(position);
        });
    }

    setMapBounds() {
        if (this.locations.length > 1) {
            const boundsPadding = {
                top: 50,
                right: 50,
                bottom: 50,
                left: 50
            };

            this.map.fitBounds(this.bounds, {
                padding: boundsPadding,
                maxZoom: 12
            });

            google.maps.event.addListenerOnce(
                this.map,
                'bounds_changed',
                () => {
                    this.map.setZoom(this.map.getZoom() - 1);
                }
            );
        } else if (this.locations.length === 1) {
            this.map.setCenter(this.bounds.getCenter());
            this.map.setZoom(11);
        } else {
            this.map.setCenter(this.options.defaultCoordinates);
            this.map.setZoom(11);
        }
    }
}

function initializeMap(mapElementId, locations, options) {
    const locationMap = new LocationMap(mapElementId, locations, options);
    locationMap.init();
}

window.LocationMap = LocationMap;
window.initializeMap = initializeMap;
